import React from "react";
import type { PropsWithChildren } from "react";

import { horizontalProductBody } from "./HorizontalProductCard.css";

export const HorizontalProductCardBody: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={horizontalProductBody}>{children}</div>;
};
